import { useOpenSearchKebabEvents } from 'hooks/events/useOpenSearchKebabEvents';
import { useAddContact, useRemoveContact } from 'hooks/queries/useContactListQuery';
import { SEARCH_TRUCKER_KEY } from 'hooks/queries/useOpenSearchQuery';
import { useGetTruckerQueriesData } from 'hooks/useGetTruckerQueriesData';
import { useOpenSearchContext } from 'hooks/useOpenSearchContext';
import { TContactListProps } from 'open-search/types';
import { TextsSearchTrucker } from '../types';

export function useContactList() {
  const { contactListFeatureData } = useGetTruckerQueriesData();

  const { setIsKebabVisible, searchTruckerData } = useOpenSearchContext();

  const { isPending: isLoadingAdd, mutate: mutateAdd } = useAddContact(
    searchTruckerData?.trucker?.uuid,
    SEARCH_TRUCKER_KEY
  );
  const { isPending: isLoadingRemove, mutate: mutateRemove } = useRemoveContact(
    searchTruckerData?.trucker?.uuid,
    SEARCH_TRUCKER_KEY
  );

  const { sendKebabEvents } = useOpenSearchKebabEvents();

  const handleCloseKebab = () => setIsKebabVisible(false);

  const handleAddContact = () => {
    handleCloseKebab();
    mutateAdd();
    sendKebabEvents(searchTruckerData, 'trucker_search_driver_kebab_add_contact', 'add');
  };

  const handleRemoveContact = () => {
    handleCloseKebab();
    mutateRemove();
    sendKebabEvents(searchTruckerData, 'trucker_search_driver_kebab_remove_contact', 'remove');
  };

  const propsContactList: TContactListProps = {
    addContact: {
      states: { textContent: TextsSearchTrucker.textKebabAddContact },
      events: {
        onClick: () => handleAddContact(),
      },
      isLoading: isLoadingAdd,
    },
    removeContact: {
      states: { textContent: TextsSearchTrucker.textKebabRemoveContact },
      events: {
        onClick: () => handleRemoveContact(),
      },
      isLoading: isLoadingRemove,
    },
    inContactList: searchTruckerData?.trucker?.inContactList,
    showAddRemoveContact: contactListFeatureData?.access,
  };

  return { propsContactList };
}
